import Api from '@/api/api'

export default {
  getConfiguration() {
    return Api.get(`/api/Configuration/GetConfigurationProfiles`);
  },
  addConfiguration(data) {
    return Api.post(`/api/Configuration/AddConfigurationProfile?TenantID=${data.tenantId}`, data);
  },
  deleteConfiguration(id) {
    return Api.delete(`/api/Configuration/DeleteConfigurationProfile?Id=${id}`);
  },
  updateConfiguration(editId, data) {
    return Api.put(`/api/Configuration/UpdateConfigurationProfile?Id=${editId}`, data);
  },
  getDBDetails() {
    return Api.get(`/api/Configuration/GetConfigDBDetails`);
  },
  addDBDetail(data) {
    console.log("Data : ",data)
    return Api.post('/api/Configuration/AddConfigDBDetail',data)
  },
  updateDBDetail(editId, data) {
    return Api.put(`/api/Configuration/UpdateConfigDBDetail?Id=${editId}`, data);
  },
  getInitialData() {
    return Api.get(`/api/InitialData/GetSuperAdminInitialData`);
},  
}